import { AnaBizApplicationListStoreModel } from '@common/interfaces/ana-biz-application-list/ana-biz-application-list-store-model';
/**
 * AnaBizApplicationList model details
 */
export interface AnaBizApplicationListStateDetails {}

/**
 * AnaBizApplicationList store state
 */
export interface AnaBizApplicationListState extends AnaBizApplicationListStateDetails {
  model: AnaBizApplicationListStoreModel | null;
}

/**
 * Name of the AnaBizApplicationList Store
 */
export const ANA_BIZ_APPLICATION_LIST_STORE_NAME = 'anaBizApplicationList';

/**
 * AnaBizApplicationList Store Interface
 */
export interface AnaBizApplicationListStore {
  /** AnaBizApplicationList state */
  [ANA_BIZ_APPLICATION_LIST_STORE_NAME]: AnaBizApplicationListState;
}
